import axios from '@/services/api'

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addSettings = (data) => axios.post('/api/settings', data)

/**
 *
 * @returns {Promise<Object>}
 */
export const getSettings = () => {
	return axios.get('/api/settings/web')
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const changePassword = (data) => {
	return axios.put(`/api/change-password`, data)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const setNotifications = (data) => {
	return axios.post('/api/settings/web', data)
}

/**
 * @returns {Promise<Object>}
 */
export const getSettingsUrl = () => axios.get('/api/setting/api/get-param')

/**
 * @returns {Promise<Object>}
 */
export const fetchChapters = () => axios.get('/api/chapters')

/**
 * @returns {Promise<Object>}
 */
export const getDwhUrl = () => axios.get('/api/dwh/api/get-param')

/**
 * @returns {Promise<Object>}
 */
export const getRegistrFields = (id) =>
	axios.get(`/api/users/get-registration-fields?expand=registration&user_category_id=${id}`)

/**
 * @returns {Promise<Object>}
 */
export const getAdvertisementUrl = () => axios.get('/api/adver/api/get-param')

export const getListBySource = (source, page = 1) => axios.get(`/api/list/${source}?page=${page}`)
